import { Link } from "react-router-dom";
import { Star, MapPin, Clock, ShieldCheck } from "lucide-react";
import { money } from "@/api";

export const CoachCard = ({ coach, selected, onCompare }) => (  <article
    data-testid={`coach-card-${coach.id}`}
    className="group relative border border-white/10 bg-[#121212] hover:border-[#00e5ff]/50 transition-colors duration-200 flex flex-col"
  >
    <div className="relative h-44 overflow-hidden">
      <img src={coach.photo} alt={coach.name} className="w-full h-full object-cover opacity-70 group-hover:opacity-90 transition-opacity duration-300" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#121212] via-[#121212]/40 to-transparent" />
      <div className="absolute bottom-3 left-4 right-4">
        <h3 className="display text-2xl uppercase tracking-tight font-bold leading-none flex items-center gap-1.5">
          {coach.name}
          {coach.verified && <ShieldCheck data-testid={`verified-badge-${coach.id}`} className="w-4 h-4 text-[#00e5ff]" title="Verified coach" />}
        </h3>
        <p className="text-xs text-zinc-400 mt-1 flex items-center gap-1">
          <MapPin className="w-3 h-3" /> {coach.city}{coach.region ? `, ${coach.region}` : ""}
        </p>
      </div>
      <div className="absolute top-3 right-3 bg-black/80 border border-white/10 px-2 py-1 flex items-center gap-1">
        <Star className="w-3 h-3 text-[#00e5ff] fill-[#00e5ff]" />
        <span className="text-xs font-semibold">{coach.rating}</span>
        <span className="text-[10px] text-zinc-500">({coach.reviews_count})</span>
      </div>
      <div className="absolute top-3 left-3 bg-[#00e5ff] text-black text-[9px] font-bold uppercase tracking-widest px-2 py-1">
        {coach.category || "Goalie Coach"}
      </div>
    </div>

    <div className="p-5 flex flex-col gap-4 flex-1">
      <p className="text-sm text-zinc-400 leading-relaxed line-clamp-2">{coach.headline}</p>
      <div className="flex flex-wrap gap-1.5">
        {coach.specialties.slice(0, 3).map((s) => (
          <span key={s} className="text-[10px] uppercase tracking-wide border border-white/10 text-zinc-300 px-2 py-1">{s}</span>
        ))}
      </div>
      <div className="flex items-center gap-4 text-xs text-zinc-500">
        <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {coach.experience_years} yrs exp</span>
        <span>{coach.levels.join(" · ")}</span>
      </div>
      <div className="mt-auto flex items-end justify-between pt-2 border-t border-white/5">
        <div>
          <span className="text-[10px] uppercase text-zinc-500 block">From</span>
          <span className="display text-3xl font-bold text-[#00e5ff] leading-none">{money(coach.hourly_from)}</span>
        </div>
        <div className="flex items-center gap-2">
          <button
            data-testid={`compare-toggle-${coach.id}`}
            onClick={() => onCompare(coach)}
            className={`text-[10px] uppercase tracking-wide border px-3 py-2 transition-colors duration-200 ${
              selected ? "border-[#ff3b30] text-[#ff3b30]" : "border-white/15 text-zinc-400 hover:border-white/40"
            }`}
          >
            {selected ? "Remove" : "Compare"}
          </button>
          <Link
            to={`/coaches/${coach.id}`}
            data-testid={`view-coach-${coach.id}`}
            className="bg-[#00e5ff] text-black text-[11px] font-bold uppercase tracking-wide px-4 py-2 hover:bg-[#00b3cc] transition-colors duration-200"
          >
            View
          </Link>
        </div>
      </div>
    </div>
  </article>
);
